import React from 'react';
import PropTypes from 'prop-types';

import {Box, Container, Grid, GridItem} from '@spothero/ui';

import {
    IMAGE_PROP_TYPES,
    CTA_BUTTON_PROP_TYPES,
    RICHTEXT_PROP_TYPES,
    SLICE_PROP_TYPES,
} from 'cms/proptypes';
import {getSliceThemeVariables} from 'cms/utils';
import HeroTextBlock from 'cms/components/hero-text-block';

const HeroSection = ({slice}) => {
    const {
        primary: {
            hero_secondary_title: heroSecondaryTitle,
            hero_slice_background_image: backgroundImage,
            hero_slice_theme: sliceTheme,
            hero_text: heroText,
            page_title: pageTitle,
            section_id: sectionId,
        },
        items,
    } = slice;
    const {textColor, backgroundColor} = getSliceThemeVariables(sliceTheme);

    const textBlockProps = {
        pageTitle,
        heroSecondaryTitle,
        heroText,
        items,
        sliceTheme,
    };

    return (
        <Box
            as="section"
            id={sectionId || null}
            data-testid="HeroSection"
            color={textColor}
            backgroundImage={
                backgroundImage.url ? `url('${backgroundImage.url}')` : null
            }
            backgroundColor={backgroundColor}
            backgroundSize="cover"
            backgroundPosition="center"
            paddingTop={{base: 14, tablet: 32}}
            paddingBottom={{base: 14, tablet: 32}}
        >
            <Container>
                <Box textAlign="center">
                    <Grid>
                        <GridItem
                            colStart={{base: 0, desktop: 2}}
                            colSpan={{base: 12, desktop: 10}}
                        >
                            <HeroTextBlock {...textBlockProps} />
                        </GridItem>
                    </Grid>
                </Box>
            </Container>
        </Box>
    );
};

/* eslint-disable camelcase */
HeroSection.propTypes = {
    slice: PropTypes.shape({
        ...SLICE_PROP_TYPES,
        primary: PropTypes.shape({
            hero_secondary_title: RICHTEXT_PROP_TYPES,
            hero_slice_background_image: IMAGE_PROP_TYPES,
            hero_slice_theme: PropTypes.string.isRequired,
            hero_text: RICHTEXT_PROP_TYPES.isRequired,
            page_title: RICHTEXT_PROP_TYPES.isRequired,
            section_id: PropTypes.string.isRequired,
        }).isRequired,
        items: PropTypes.arrayOf(CTA_BUTTON_PROP_TYPES),
    }).isRequired,
};

export default HeroSection;
